enum AlertState {
  OK = 'OK',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

enum BaseNotificationDelay {
  OK = 3600, //1 hour
  WARNING = 3600 * 8,
  CRITICAL = 3600 * 8,
}

export { AlertState, BaseNotificationDelay };
